// extracted by mini-css-extract-plugin
export default {"Body":"InventoryPage_Body__gsMIz","title":"InventoryPage_title__zP9gu","eqp":"InventoryPage_eqp__Lxn2+","img":"InventoryPage_img__oQVi7","name":"InventoryPage_name__6h2z+"};